<template>
  <div class="w100 p-re" :class="!pitem.available&&modifiersChoose?'grayscale':''">
    <span v-if="pitem.discount && pitem.discount.special" class="specialText">{{
      pitem.discount.special
    }}</span>
    <div class="flex flexcc p-re">
      <div class="cakeEmpty"></div>

      <img
        :src="globalDataUrl + (pitem.image || pitem.img)"
        alt=""
        class="cakeImg"
      />
    </div>

    <p class="color1 bold overflow2 h40 mobileH30 mt10">{{ pitem.name }}</p>
    <p class="h20">{{ pitem.specification }}</p>
    <p class="overflow3 mt20 h60 pDesc mDescBox">{{ pitem.descrip }}</p>
    <div v-if="pitem.discount" class="flexcc mt25 mb25 h20 mmt5 mmb5 p-re">
      <p class="color1 bold mr5">
        <span v-if="pitem.discount.discountmothod == 0">
          RM{{ (pitem.price - pitem.discount.discountamount).toFixed(2) }}</span
        >
        <span v-else-if="pitem.discount.discountmothod == 1">
          RM{{
            $roundAmount(
              (pitem.price * pitem.discount.discountamount) / 100
            ).toFixed(2)
          }}
        </span>
      </p>

      <p class="pDesc" style="text-decoration: line-through">
        RM{{ pitem.price.toFixed(2) }}
      </p>
      <p v-if="businessTime" class="daojishi flexcc fs12 color1" :class="proStatus?'':'op0'">
        <img v-if="proStatus&&(proStatus.indexOf('today') ==-1 && proStatus.indexOf('expired')==-1)" src="@/assets/clock1.svg" class="clockIcon" alt="">
        {{ proStatus}}
      </p>
    </div>
    <p v-else class="color1 bold mt25 mb25 h20">
      RM{{ pitem.price.toFixed(2) }} 
    </p>
    
    <div v-if="modifiersChoose" :class="pgroup&&pgroup[flavorsIndex]&&pgroup[flavorsIndex].seNumber&&pgroup[flavorsIndex].seNumber>=pgroup[flavorsIndex].max?'maxNumber':''">
        <div v-if="!pitem.selectNumber">
          <button class="btn  w8rem addBtn"  @click="add(pitem)">{{ pitem.available||modifierid.indexOf(pitem.id)!=-1?'add':'Out of Stock' }}</button>
        </div>
        <div v-else class="flexc2 flex-around w100 addreduceBox">
          <div @click="reduce(pitem)"><img src="@/assets/reduce.png" alt="" class="cp w25"></div>
          <div>{{pitem.selectNumber}}</div>
          <div class="addBtn" @click="add(pitem)"><img src="@/assets/add.png" alt="" class="cp w25"></div>
        </div>
    </div>
    <template v-else-if="pitem.step">
      <button class="btn w90" @click="selectCombitems(pitem.id)">
        Go to customizotion
      </button>
    </template>
    
    <template v-else>
      <button class="btn w90" @click="selectFlavors(pitem, pindex)">
        {{
          pitem.hasgroup
            ? pitem.btn
              ? pitem.btn
              : "Select Flavors"
            : "Add to Cart"
        }}
      </button>
    </template>
  </div>
</template>

<script>
import { log } from "console";
import { mapState, mapMutations } from "vuex";
import Cart from "@/components/Cart/Cart";
export default {
  components: { Cart },
  computed: {
    ...mapState(["selectList","stepIndex","flavorsIndex"]),
    proStatus(){
      // console.log(this.pitem.discount)
      if(!this.pitem||!this.pitem.discount||((this.pitem.discount.starttime=="00:00:00"||!this.pitem.discount.starttime)&&(this.pitem.discount.endtime=="23:59:59"||!this.pitem.discount.endtime))){
        return false;
      }
      if(this.businessTime<this.pitem.discount.starttime){
        //还没开始
        
        this.$emit("editStatusFn",{status:0,menuIndex:this.menuIndex,pindex:this.pindex})
        return "Hot deal is coming soon at "+this.pitem.discount.starttime+" today";
      }else if(this.businessTime>this.pitem.discount.endtime){
        //已经结束
        this.$emit("editStatusFn",{status:0,menuIndex:this.menuIndex,pindex:this.pindex})
        return "Discount expired";
      }else if(this.businessTime>this.pitem.discount.starttime&&this.businessTime<this.pitem.discount.endtime){
        //时间范围内，需要倒计时
        var endTime = new Date("2000-01-01 " + this.pitem.discount.endtime);
        var currentTime = new Date("2000-01-01 " + this.businessTime);
        // 计算剩余时间的毫秒数
        var timeDiff = endTime - currentTime;
        var hours = Math.floor(timeDiff / (1000 * 60 * 60));
        var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        this.$emit("editStatusFn",{status:1,menuIndex:this.menuIndex,pindex:this.pindex})
        // 格式化小时和分钟
        var formattedTime = hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0")+ ":" + seconds.toString().padStart(2, "0");
        return formattedTime;
      }else{
        return false;
      }
    }
  },
  data(){
    return{
      modifierid:""
    }
  },
  props: ["pitem", "pindex", "menu", "menuIndex", "orderstoreid", "cartInfo","modifiersChoose","pgroup","isNormalProduct","businessTime"],
  created() {
    this.globalDataUrl = this.$root.globalData.url;
    // console.log(222)
    // console.log(Cart, 2222);
  },
  methods: {
    ...mapMutations(["ADD_SELECTLIST","ADD_PRODUCTOBJ","ADD_MODIFIERGROUP","EDIT_STEPPRODUCT","EDIT_CHOOSEMODIFIERARR"]),
    getGroup(categoryid, productid, orderstoreid, discountid) {
      let that = this;
      return new Promise((resolve, reject) => {
        this.$http
          .Get(
            "mobile/menumodiarray?categoryid=" +
              categoryid +
              "&productid=" +
              productid +
              "&orderstoreid=" +
              orderstoreid +
              "&discountid=" +
              discountid,
            {}
          )
          .then(
            (res) => {
              if (res.code == 1) {
                // console.log(res);
                resolve(res);
              } else {
                // alert(res.msg);
              }
              that.$loading().close();
            },
            (err) => {
              // console.log(err);
              that.$loading().close();
            }
          );
      });
    },
    add(pitem){
      // console.log("pitem",pitem)
      // if(pitem.selectNumber){
      //   pitem.selectNumber++
      // }else{
      //   pitem.selectNumber=1
      // }
      // pitem.selectNumber=1
      this.EDIT_CHOOSEMODIFIERARR({"modifiersObj":pitem,"type":"add"})
      // this.$forceUpdate()
      // modifierGroup[mIndex].chooseModifierArr[i]=modifiers[index];
    },
    reduce(pitem){
      // pitem.selectNumber--;
      this.EDIT_CHOOSEMODIFIERARR({"modifiersObj":pitem,"type":"reduce"})
    },
    selectCombitems(id) {
      this.ADD_SELECTLIST(this.pitem);
      // this.$emit("productListFn", this.pitem.step[0].product);
    },
    sortModifiers(modifierGroup){
      modifierGroup.forEach(mEle=>{
        // mEle.modifiers=this.sortFn(mEle.modifiers)
        mEle.modifiers.sort(function(a,b){
          return a.name.localeCompare(b.name)
        })
      })
    },
    // moveArray(arr, sourceIndex, targetIndex) {
    //   // splice 将目标元素替换并将原结果扔回来赋值给它
    //   arr[sourceIndex] = arr.splice(targetIndex, 1, arr[sourceIndex])[0];
    // },
    // sortFn(arr){
    //   let that=this;
    //   var sourceIndexes = [];
    //   arr&&arr.forEach((item, index) => {
    //     if (item.available == 0) {
    //       sourceIndexes.push(index);
    //     }
    //   });

    //   // 遍历索引数组，移动元素
    //   sourceIndexes.forEach((sourceIndex) => {
    //     that.moveArray(arr, sourceIndex, arr.length);
    //   });
    //   // console.log(arr);
      
    //   // 过滤数组，去除 undefined 项
    //   var result = arr&&arr.filter((item) => {
    //     return item !== undefined || !!item;
    //   });
    //   console.log(result);
    //   return result;
    // },
    selectFlavors(pitem, pindex) {
      let that = this;
      this.$loading();
      this.getGroup(
        pitem.categoryid,
        pitem.id,
        this.orderstoreid,
        pitem.discount ? pitem.discount.id : 0
      ).then((res) => {
        that.$loading().close();
        // console.log(pindex)
        if (that.selectList &&JSON.stringify(that.selectList) != '{}') {
          // console.log(414142412,that.selectList.step[that.stepIndex].product[pindex])
          
          that.EDIT_STEPPRODUCT(that.selectList.step[that.stepIndex].product[pindex])
        }

        let modifierGroup = res.modiarr[0].modigroup;
        that.sortModifiers(modifierGroup);
        // that.sortFn()
        let trackingData = pitem;
        if (modifierGroup && modifierGroup.length) {
          if(!this.isNormalProduct){
            this.ADD_MODIFIERGROUP(modifierGroup);
            return;
          }
          
          // this.INIT_CHOOSEMODIFIERARR();
          // return;
          this.braze.logCustomEvent("Product viewed", {
            "Product ID": trackingData.id,
            Category: pitem.categoryname,
            Price: trackingData.price,
            Campaign: trackingData.discount
              ? trackingData.discount.campaignname
              : "",
            Timestamp: new Date(),
            Source: "",
          });
          let params = {
            menu: this.menu,
            pindex: pindex,
            menuIndex: this.menuIndex,
            modifierGroup,
          };
          // console.log(params);
          this.$router.push({
            name: "orderDetail",
            params,
          });
        } else {
          this.addToCart(pitem, pindex, modifierGroup);
        }
      });
    },
    addToCart(pitem, pindex, modifierGroup) {
      let that = this;
      let data = Cart.methods.checkData(
        this.menu,
        this.menuIndex,
        pindex,
        modifierGroup,
        that.orderstoreid
      );
      data = Cart.methods.checkSame(data, that.cartInfo);
      if (!data) return; //购物车添加失败，原因1、优惠不能共享
      this.$loading();
      this.$http.Post("mobile/cart", data).then(
        (res) => {
          if (res.code == 1) {
            this.$emit("addCartBooleanFn", true);
            this.$emit("cartInfoFn", data);
          } else {
            alert(res.msg);
          }
          that.$loading().close();
        },
        (err) => {
          console.log(err);
          that.$loading().close();
        }
      );
    },
  },
};
</script>

<style scoped>
.cakeImg {
  width: 10rem;
}
.cakeEmpty {
  height: 10rem;
}
.pDesc {
  color: rgb(129, 129, 129);
}
.w90 {
  width: 90%;
  margin: 0 auto;
}
.specialText {
  color: #511f26;
  background: #64cfe3;
  padding: 10px 18px;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  white-space: nowrap;
  position: absolute;
  left: 0;
  top: -20px;
  font-weight: bold;
  font-size: 12px;
  z-index: 5;
}
.maxNumber .addBtn {
  pointer-events: none;
  opacity: .3;
}
.h40 {
  height: 40px;
}

.h20 {
  height: 20px;
}

.h60 {
  height: 50px;
}
.w50 {
  width: 50%;
}
.w8rem{
  width: 8rem;
}
.daojishi{
  
  position: absolute;
  bottom: -25px;
  width: 100%;
  height: 25px;
}
.clockIcon{
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.op0{
  opacity: 0;
}
@media screen and (max-width: 768px) {
  .mflexcc {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mDescBox {
    height: 35px;
    -webkit-line-clamp: 2;
  }
  .specialText {
    left: -5px;
    font-size: 12px;
  }
  .mobileH30 {
    height: 30px;
  }
  .h40 {
    height: 40px;
  }

  .h20 {
    height: 20px;
  }

  .h60 {
    height: 50px;
  }
  .w50 {
    width: 50%;
  }
}
</style>